<template>
    <form v-on:submit.prevent="addNewCropTip">
        <div class="modal-card">
            <header class="modal-card-head" style="background:#222">
                <p class="modal-card-title" style="color:white"><span style="color: #7cda24">Add New Crop Tip</span> {{cropTip._id}}</p>
            </header>
            <section class="modal-card-body">
                <b-field label="Days">
                    <b-input
                        type="text"
                        v-model="cropTip.days"
                        placeholder="10-12 "
                        >
                    </b-input>
                </b-field>
                <b-field label="Crop Tip">
                  <b-input type="textarea" v-model="cropTip.tip"></b-input>
                </b-field>
            </section>
            <footer class="modal-card-foot">
                <button class="button is-primary is-outlined" type="submit">Add</button>
                <button class="button is-dark" type="button" @click="$parent.close">Close</button>
            </footer>
        </div>
    </form>
</template>

<script>
import { ucFirst, currencies, ls } from '@/helpers';
import { mapGetters } from 'vuex';
import decode from 'jwt-decode'

export default {
    name: "addNewCropTipModal",
    data() {
        return {
        }
    },
    props: ['cropTip'],
    computed: {
        userAuth() {
          return ls('token') ? decode(ls('token')) : null;
        },
        isAdmin() {
          return this.userAuth ? this.userAuth.subject === "admin" : false;
        },
        isProvincialManager() {
          return this.userAuth ? this.userAuth.type === "provincial-manager" : false;
        },
    },
    created() {
    },
    methods: {
        addNewCropTip() {
          const loading = this.$loading.open();
          // let formData =  this.cropTip
          // formData = formData.split(",")
          // return console.log(formData)
          this.$store.dispatch('addNewCropTip', this.cropTip).then(() => {
            loading.close();
            this.$parent.close();
            this.$toasted.global.success(`Crop Tip Added Successfully!`);
            this.$emit('reload');
          }).catch(e=> {
            loading.close();
            console.log('Exception when adding tip',e);
            this.$toasted.global.error('Failed to add tip. Please try again.');
          })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/CropManager/AddCropTipModal.vue